import request from '../request';

const server = {
  // 获取当前登录用户企业电子发票开通信息
  invoiceInfo(params) {
    return request.fetch(
      '/user-center/companyElectronicInvoiceInfo/getInfo',
      params
    );
  },
  // 提交百望云电子发票申请
  submitBaiWangInvoice(params) {
    return request.post(
      '/user-center/companyElectronicInvoiceInfo/submitBaiWangInvoice',
      params
    );
  },
  // 获取纳税省份集合
  getTaxProvinces(params) {
    return request.fetch(
      '/user-center/companyElectronicInvoiceInfo/getTaxProvinces',
      params
    );
  },
  // 交易参数配置-供应商电子发票服务启用情况
  getElectronicInvoiceSwitch(params) {
    return request.fetch(
      '/user-center/companyConfig/getElectronicInvoiceSwitch',
      params
    );
  },

  // 交易参数配置-供应商电子发票服务改变
  updateElectronicInvoiceSwitch(params) {
    return request.post(
      '/user-center/companyConfig/updateElectronicInvoiceSwitch',
      params
    );
  },
  // 百望云电子发票申请
  applyElectronicInvoice(params) {
    return request.post(
      '/transaction-center/invoiceListSupplier/applyElectronicInvoice',
      params
    );
  },
  // 判断是不是集成供应商
  companyWhetherSystemIntegration(params) {
    return request.post(
      '/api-register/apiUser/companyWhetherSystemIntegration',
      params
    );
  },
};
export default server;
